import React from "react";
import { VirtuosoGrid, type VirtuosoGridHandle, type VirtuosoGridProps } from "react-virtuoso";
import { type IGridListVirtualizedContext, ListVirtualizedProvider } from "./context";
import { VirtuosoItem } from "./item";
import { VirtuosoList } from "./list";

export type IGridListVirtualizedProps<D> = VirtuosoGridProps<D> & IGridListVirtualizedContext;

export const GridListVirtualized = React.forwardRef(function ListVirtualized<D>(
  { List, ListItem, ...props }: IGridListVirtualizedProps<D>,
  ref: React.Ref<VirtuosoGridHandle> | undefined
): React.ReactElement | null {
  return (
    <ListVirtualizedProvider List={List} ListItem={ListItem}>
      <VirtuosoGrid
        {...props}
        ref={ref}
        components={{
          ...props.components,
          List: VirtuosoList,
          Item: VirtuosoItem,
        }}
      />
    </ListVirtualizedProvider>
  );
});
